import { trackStatistic as trackStatisticRequest } from '@/lib/api/common/statistic.api';

export const trackStatistic = async (
  key: string,
  itemId?: number | string,
  userId?: number
): Promise<void> => {
  try {
    await trackStatisticRequest(key, itemId, userId);
  } catch (error) {
    console.error(`Failed to track statistic "${key}":`, error);
  }
};
